import router from './router'
import store from './store'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import Vue from 'vue';
const whiteList = ['/login', '/auth-redirect', '/wechatSuccess', '/personalInfo', '/404', '403', '/500'] // no redirect whitelist
let demoObj = getQuery(window.location.href);
let loginFlag = false;
function getQuery(url) {
	const str = url.substr(url.indexOf('?') + 1);
	const arr = str.split('&');
	const result = {}
	for (let i = 0; i < arr.length; i++) {
		const item = arr[i].split('=');
		result[item[0]] = item[1];
	}
	return result;
}
function login302() {
	store.commit('app/SET_IS_LOGIN', false);
	let param;
	Vue.prototype.$api.ppnLogin((window.location.href.indexOf('?') > -1) ? `?${window.location.href.split('?')[1]}` : '').then(res => {
		if (res.errcode != 0) return;
		if(res.data?.redirectUrl) {
			window.location.href = res.data?.redirectUrl;
		} else {
			store.commit('app/SET_IS_LOGIN', true);
		}
	});
}
router.beforeEach(async (to, from, next) => {
	demoObj = getQuery(window.location.href);
	document.title = getPageTitle(to.meta.title);
	const hasToken = localStorage.getItem('access_token');
	if (demoObj.code && !hasToken) {
		Vue.prototype.$api.ppnGetToken({ code: demoObj.code }).then(res => {
			if (res.errcode == 0) {
				if (res.data) {
					localStorage.setItem('access_token', res.data.access_token);
					localStorage.setItem('refresh_token', res.data.refresh_token);
					store.dispatch("user/setToken", {
						access_token: res.data.access_token,
						refresh_token: res.data.refresh_token,
					});
					loginFlag = true;
					window.location.reload();
				} else {
					console.log('未获取到tk')
					login302()
				}
			} else {
				console.log('获取tk失败')
				login302()
			}
		});
	} else {
		if (hasToken || loginFlag) {
			if (loginFlag) {
				window.history.replaceState("", "", `${window.location?.origin}/ocs/index.html`);
				loginFlag = false;
			}
			if (to.path === '/login') {
				next({ path: '/' })
			} else {
				const hasRoles = store.getters.roles && store.getters.roles.length > 0
				if (hasRoles) {
					next();
				} else {
					try {
						const { roles } = await store.dispatch('user/getInfo')
						const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
						for (let i = 0, length = accessRoutes.length; i < length; i += 1) {
							const element = accessRoutes[i];
							router.addRoute(element);
						}
						next({ ...to, replace: true })
					} catch (error) {
						Message.error(error || 'Has Error')
					}
				}
			}
		} else {
			if (whiteList.indexOf(to.path) !== -1) {
				if (to.path === '/login' && !demoObj.code) {
					login302();
				}
				next();
			} else {
				if (!demoObj.code) {
					login302()
				}
				next(`/login`)
			}
		}
	}
});